import React from 'react';
import { ArrowRight, Star, Check } from 'lucide-react';
import { services } from '../data/content';

export default function Services() {
  return (
    <section id="leistungen" className="py-20 md:py-28 bg-[#F4EFE7]">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-3xl">
          <span className="crown-divider text-[#B8892A]">Unsere Leistungen</span>
          <h2 className="mt-4 text-3xl sm:text-4xl md:text-5xl font-extrabold text-[#0B1E44] leading-tight">
            Alles aus einer Hand – <span className="text-[#DC2626]">Sauberkeit, die bleibt.</span>
          </h2>
          <p className="mt-5 text-slate-600 text-lg leading-relaxed">
            Ein breites Spektrum für Immobilien, Außenflächen und gewerbliche Objekte – einzeln buchbar oder als komplettes Pflege- und Sanierungskonzept.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {services.map((s) => (
            <article key={s.id} className="group relative bg-white rounded-2xl overflow-hidden card-shadow border border-slate-100 flex flex-col hover:-translate-y-1.5 transition-transform duration-300">
              <div className="relative aspect-[16/10] overflow-hidden">
                <img src={s.image} alt={s.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
                <div className="absolute inset-0 bg-gradient-to-t from-[#0B1E44]/70 via-transparent to-transparent" />
                {s.popular && (
                  <span className="absolute top-3 left-3 inline-flex items-center gap-1 bg-[#DC2626] text-white text-[11px] font-bold uppercase tracking-wide px-2.5 py-1 rounded">
                    <Star className="w-3 h-3" /> Beliebt
                  </span>
                )}
                <h3 className="absolute bottom-3 left-4 right-4 text-white font-bold text-xl drop-shadow">{s.title}</h3>
              </div>
              <div className="p-6 flex-1 flex flex-col">
                <p className="text-slate-700 text-[15px] leading-relaxed">{s.intro}</p>
                <ul className="mt-4 grid grid-cols-2 gap-x-3 gap-y-1.5">
                  {s.bullets.map((b, i) => (
                    <li key={i} className="text-sm text-slate-600 flex items-center gap-1.5">
                      <Check className="w-3.5 h-3.5 text-[#B8892A]" /> {b}
                    </li>
                  ))}
                </ul>
                <a href="#kontakt" className="mt-6 inline-flex items-center gap-1.5 text-[#1E3A8A] font-semibold text-sm group/link">
                  Anfragen
                  <ArrowRight className="w-4 h-4 transition-transform group-hover/link:translate-x-1" />
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}
